import { IMenuItem } from '../../interfaces/sidebar';
import { EUserProfileIds } from '../../interfaces/user';

export const MENUS_COMMON_LOGGED: IMenuItem[] = [
	{ label: 'Home', icon: 'fa-solid fa-home', route: '/' },
	{ label: 'Conta', icon: 'fa-solid fa-user', route: '/account' },
];

export const MENUS_VISITOR = (actions: any): IMenuItem[] => [
	{ label: 'Home', icon: 'fa-solid fa-home', route: '/' },
	{
		label: 'Cadastrar',
		icon: 'fa-solid fa-user-plus',
		route: '/new-customer',
		// action: actions.register,
	},
	{ label: 'Entrar', icon: 'fa-solid fa-sign-in', action: actions.login },
];

export const MENUS_BY_ROLE = (
	actions: any
): Record<EUserProfileIds, IMenuItem[]> => ({
	[EUserProfileIds.PORTAL_MANAGER]: [
		{
			label: 'Versões',
			icon: 'fa-solid fa-code-compare',
			route: 'preferences/records/versions',
		},
	],

	[EUserProfileIds.APPLICATION_ADMIN]: [
		{
			label: 'Dashboard',
			icon: 'fa-solid fa-chart-column',
			route: '/dashboard',
			feature: 'dashboard',
		},
		{
			label: 'Portal',
			icon: 'fa-solid fa-cart-shopping',
			route: '/preferences/b2b-portal',
			module: 'selling',
		},
		{
			label: 'Força de Vendas',
			icon: 'fa-solid fa-mobile',
			route: '/preferences/sales-force',
			module: 'afv',
		},
		{
			label: 'Integrações',
			icon: 'fa-solid fa-link',
			route: '/preferences/integrations',
		},
		{
			label: 'Área do Cliente',
			icon: 'fa-solid fa-file-invoice-dollar',
			route: '/preferences/client-area',
			module: 'backoffice',
		},
		{
			label: 'Cadastros',
			icon: 'fa-solid fa-folder',
			route: '/preferences/records',
		},
		{
			label: 'Pedidos',
			icon: 'fa-solid fa-bag-shopping',
			route: '/dashboard/orders',
		},
		{
			label: 'Relatórios',
			icon: 'fa-solid fa-file-contract',
			route: '/preferences/reports',
		},
		{
			label: 'Agenda e Rotas',
			icon: 'fa-solid fa-calendar',
			route: '/preferences/schedule-and-routes',
			feature: 'userSchedules',
		},
		{
			label: 'Configurações',
			icon: 'fa-solid fa-cog',
			action: actions.openSettingsMenu,
		},
	],

	[EUserProfileIds.CUSTOMER]: [
		// {
		// 	label: 'Carrinho',
		// 	icon: 'fa-solid fa-shopping-cart',
		// 	action: actions.cart,
		// },
		{
			label: 'Favoritos',
			icon: 'fa-solid fa-heart',
			action: actions.favorites,
		},
		{
			label: 'Pedidos',
			icon: 'fa-solid fa-bag-shopping',
			route: '/account/orders',
		},
		{
			label: 'Financeiro',
			icon: 'fa-solid fa-wallet',
			route: '/client-area/accounts-receivable',
			module: 'backoffice',
		},
		{
			label: 'Notas Fiscais',
			icon: 'fa-solid fa-file-invoice-dollar',
			route: '/client-area/invoices',
			module: 'backoffice',
		},

		{
			label: 'Categorias',
			icon: 'fa-solid fa-tags',
			route: '/client-area/categories',
			module: 'backoffice',
		},
	],

	[EUserProfileIds.CUSTOMER_ADMIN]: [
		// {
		// 	label: 'Carrinho',
		// 	icon: 'fa-solid fa-shopping-cart',
		// 	action: actions.cart,
		// },
		{
			label: 'Favoritos',
			icon: 'fa-solid fa-heart',
			action: actions.favorites,
		},
		{
			label: 'Pedidos',
			icon: 'fa-solid fa-bag-shopping',
			route: '/account/orders',
		},
		{
			label: 'Financeiro',
			icon: 'fa-solid fa-wallet',
			route: '/client-area/accounts-receivable',
			module: 'backoffice',
		},
		{
			label: 'Notas Fiscais',
			icon: 'fa-solid fa-file-invoice-dollar',
			route: '/client-area/invoices',
			module: 'backoffice',
		},
		{
			label: 'Categorias',
			icon: 'fa-solid fa-tags',
			route: '/client-area/categories',
			module: 'backoffice',
		},
		{
			label: 'Cadastros',
			icon: 'fa-solid fa-folder',
			route: '/preferences/records',
		},
	],

	[EUserProfileIds.SELLER]: [
		{
			label: 'Dashboard',
			icon: 'fa-solid fa-chart-column',
			route: '/dashboard',
			feature: 'dashboard',
		},
		{
			label: 'Cadastros',
			icon: 'fa-solid fa-folder',
			route: '/preferences/records',
		},
		{
			label: 'Pedidos',
			icon: 'fa-solid fa-bag-shopping',
			route: '/dashboard/orders',
		},
		{
			label: 'Relatórios',
			icon: 'fa-solid fa-file-contract',
			route: '/preferences/reports',
		},
		// {
		// 	label: 'Speedchat',
		// 	icon: 'pi pi-whatsapp',
		// 	route: '/integrations/speedchat',
		// 	module: 'speedChat',
		// },
		{
			label: 'Agenda e Rotas',
			icon: 'fa-solid fa-calendar',
			route: '/preferences/schedule-and-routes',
			feature: 'userSchedules',
		},
		{
			label: 'Suporte e Ajuda',
			icon: 'fa-solid fa-question-circle',
			route: '/suporte',
		},
	],

	[EUserProfileIds.INTEGRATOR]: [], // futuro
	[EUserProfileIds.GUEST]: MENUS_VISITOR(actions),
});

export const MENU_LOGOUT = (actions: any): IMenuItem => ({
	label: 'Sair',
	icon: 'fa-solid fa-sign-out',
	action: actions.logout,
});
